import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as types from './header-constants';

export const menuVisible = handleActions(
  {
    [types.SET_MENU_VISIBLE]: (state, { payload }) => payload,
  },
  true,
);

export default combineReducers({
  menuVisible,
});
